/* eslint-disable camelcase */
import * as React from "react"
import { useRef } from "react"
import * as yup from "yup"
import { Appearance, TextInput } from "react-native"
import { Farm } from "../../../database"
import { FormProps } from "../form"
import { Formik } from "formik"
import { ModelField } from "../../field/model-field/model-field"
import { NumeralField } from "../../field/numeral-field/numeral-field"
import { observer } from "mobx-react-lite"
import { translate } from "../../../i18n"

export interface PondPreCreateMultipleFormProps extends FormProps {
  /**
   * An optional style override useful for padding & margin.
   */
  initialValues?: {
    farm_id?: number
    total_ponds?: number
  }
}

/**
 * Describe your component here
 */
export const PondPreCreateMultipleForm = observer(function PondPreCreateMultipleForm(props: PondPreCreateMultipleFormProps) {
  const {
    initialValues = {}, onSubmit, colorScheme = Appearance.getColorScheme(), innerRef,
    ...rest
  } = props

  const input = {
    total_ponds: useRef<TextInput>(),
  }

  const nextInput = {
    //
  }

  const validationSchema = yup.object({
    farm_id: yup.number().nullable().required().label(translate("pondForm.farmId")),
    total_ponds: yup.number().nullable().moreThan(0)
      .max(10, ({ max }) => translate('pondForm.totalPondsMaxMessage', { max })).required().label(translate("pondForm.totalPonds")),
  })

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      innerRef={innerRef}
      {...rest}
    >
      {({ initialValues }) => (
        <>
          <ModelField
            name="farm_id"
            txPrefix="pondForm"
            colorScheme={colorScheme}
            formControlProps={{ isRequired: true }}
            modelPickerProps={{
              Model: Farm,
              isDisabled: !!initialValues.farm_id,
            }}
          />
          <NumeralField
            name="total_ponds"
            txPrefix="pondForm"
            colorScheme={colorScheme}
            input={input}
            nextInput={nextInput}
            formControlProps={{ isRequired: true }}
            numeralInputProps={{ format: '0,0' }}
          />
        </>
      )}
    </Formik>
  )
})

PondPreCreateMultipleForm.displayName = 'PondPreCreateMultipleForm'
